module.exports = __webpack_public_path__ + "static/media/tra_mob_roa.f30f3cb9.png";